module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/btn_rireki-90337819f5bed105b670212addbd6499.png";